import React, {useState} from "react";
import {useForm} from "react-hook-form";
import BannerFields from "./BannerFields";

export default function () {
  const {register, handleSubmit, reset, control, setValue, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const bannerFields = <BannerFields {...{register, control, data, errors, setValue, watch}} />;

  return {
    setErrors,
    handleSubmit,
    setData,
    reset,
    bannerFields,
  }
}